// useLoader.ts
import { useState } from "react";

let externalSetLoader: (value: boolean) => void;

export const useLoader = () => {
  const [loader, setLoader] = useState(false);
  externalSetLoader = setLoader;
  return loader;
};

export const setGlobalLoader = (value: boolean) => {
  if (externalSetLoader) {
    externalSetLoader(value);
  }
};
